import { form } from '../../formState'

import { useTexts } from '../../hooks/useTexts'
import { createValidateCourierFilter } from '../../hooks/validations/createValidateCourierFilter'
import { UserFormValues } from '../../types'

import { CourierTerritoryAccessField } from './components/CourierTerritoryAccessField'

interface Props {
  territoriesData: uui.domain.client.rm.TerritoriesDriversAndVehicles
  territoryNames: Record<string, string>
}

export function CourierTerritoryAccessRoot(props: Props) {
  const { territoriesData, territoryNames } = props
  const texts = useTexts()
  const type = form.useFormField('type')

  form.useAddFieldValidation<'courierFilter'>('courierFilter', (field, _formApi) => {
    const validationCourierFilter = createValidateCourierFilter(
      texts,
      field.value,
      type.field.value,
    )

    return validationCourierFilter.courierFilterErrors?.message
  })

  return (
    <CourierTerritoryAccessField<'courierFilter', UserFormValues>
      name="courierFilter"
      territoriesConfig={territoriesData}
      territoryNames={territoryNames}
      validateOn="change"
    />
  )
}
